import { ENTITIES, entity } from "constant/entity";

export const determineIfCreateBarangayIsEnabled = () => {
  return entity !== ENTITIES.AKAP_BIGAS;
};
